export function isSomePropEmpty(obj) {
  const arrObj = []

  for (const [key, value] of Object.entries(obj)) {
    arrObj.push({
      key,
      value,
    })
  }

  return arrObj.some((obj) => !obj.value)
}

export function isSomePropFilled(obj) {
  const arrObj = []

  for (const [key, value] of Object.entries(obj)) {
    arrObj.push({
      key,
      value,
    })
  }

  return arrObj.some((obj) => obj.value)
}

export function allPropsContains(obj, regex) {
  const arrObj = []

  for (const [key, value] of Object.entries(obj)) {
    arrObj.push({
      key,
      value,
    })
  }

  return arrObj.every((o) => new RegExp(regex, 'gm').test(o.value))
}

export function clearProps(obj) {
  const objClean = obj

  for (const [key] of Object.entries(obj)) {
    objClean[key] = ''
  }

  return objClean
}

export function objIntoArr(obj) {
  const arr = []

  for (const [key, value] of Object.entries(obj)) {
    arr.push({ [key]: value })
  }

  return arr
}

export function areObjEqual(obj, obj2) {
  let isEqual = true

  for (const [key, value] of Object.entries(obj)) {
    if (!Object.hasOwn(obj2, key)) {
      isEqual = false
    } else {
      const indexObj2 = Object.keys(obj2).findIndex(
        (keyObj2) => keyObj2 === key,
      )

      const obj2Arr = objIntoArr(obj2)

      if (obj2Arr[indexObj2][key] !== value) {
        isEqual = false
      }
    }
  }

  return isEqual
}
